module.exports = __webpack_public_path__ + "static/3-compelling-reasons-to-bring-workers-back-into-the-office-e8343b662f6cbdde49331fde13801267.png";